import React from "react";
import HeaderSection from "./HeaderSection";
import GoalSection from "./GoalSection";

const Index = () => {
  return (
    <div className="flex flex-col items-center bg-[#f4f8f7] min-h-screen px-4 py-16" data-aos="slide-up">
      <div className="flex flex-col items-center w-full max-w-[1189px] gap-16">
        <HeaderSection />
        <GoalSection />
      </div>
    </div>
  );
};

export default Index;
